import {
  getBooleanValidationMSG,
  getNotEmptyValidationMSG,
  getNumberValidationMSG,
  getStringValidationMSG,
  getStringArrayValidationMSG,
} from "@/domain/validations/common.validations";
import { z } from "zod";
const zValidatedString = (fieldName: string) =>
  z.string({ message: getStringValidationMSG(fieldName) }).nonempty({
    message: getNotEmptyValidationMSG(fieldName),
  });

const zValidatedEmptyString = (fieldName: string) =>
  z.string({ message: getStringValidationMSG(fieldName) });

const zOptionalValidatedString = (fieldName: string) =>
  zValidatedString(fieldName).optional();

const zValidatedNumber = (fieldName: string) =>
  z.number({ message: getNumberValidationMSG(fieldName) });

const zValidatedPositiveNumber = (fieldName: string) =>
  zValidatedNumber(fieldName).min(0, {
    message: `${fieldName} debe ser un número positivo`,
  });

const zValidatedOptionalPositiveNumber = (fieldName: string) =>
  z.preprocess(
    (val) =>
      val === "" || val === null || val === undefined || Number.isNaN(val)
        ? 0
        : Number(val),
    zValidatedPositiveNumber(fieldName).optional().default(0)
  );

const zValidatedBoolean = (fieldName: string) =>
  z.boolean({
    message: getBooleanValidationMSG(fieldName),
  });

const zValidatedStringArray = (fieldName: string) =>
  z.array(
    z
      .string({ message: getStringArrayValidationMSG(fieldName) })
      .nonempty({ message: getStringArrayValidationMSG(fieldName) }),
    { message: getStringArrayValidationMSG(fieldName) }
  );

const zValidatedStringEmptyArray = (fieldName: string) =>
  z.array(z.string({ message: getStringArrayValidationMSG(fieldName) }), {
    message: getStringArrayValidationMSG(fieldName),
  });

export {
  zValidatedString,
  zValidatedEmptyString,
  zOptionalValidatedString,
  zValidatedBoolean,
  zValidatedNumber,
  zValidatedPositiveNumber,
  zValidatedStringArray,
  zValidatedStringEmptyArray,
  zValidatedOptionalPositiveNumber,
};
